export const sectionTitles = {
    hero: {
        homepage: 'sectionNavTitles.hero.homepage',
        aboutUsPage: 'sectionNavTitles.hero.aboutUsPage',
        analysisPage: 'sectionNavTitles.hero.analysisPage',
        appDevelopmentPage: 'sectionNavTitles.hero.appDevelopmentPage',
        mobileAppDevelopmentPage: 'sectionNavTitles.hero.mobileAppDevelopmentPage',
        webAppDevelopmentPage: 'sectionNavTitles.hero.webAppDevelopmentPage',
        general: 'sectionNavTitles.heroGeneral',
    },
    caseStudies: {
        homepage: 'sectionNavTitles.caseStudies.homepage',
        aboutUsPage: 'sectionNavTitles.caseStudies.aboutUsPage',
        appDevelopmentPage: 'sectionNavTitles.caseStudies.appDevelopmentPage',
        mobileAppDevelopmentPage: 'sectionNavTitles.caseStudies.mobileAppDevelopmentPage',
        webAppDevelopmentPage: 'sectionNavTitles.caseStudies.webAppDevelopmentPage',
    },
    services: {
        homepage: 'sectionNavTitles.services.homepage',
        aboutUsPage: 'sectionNavTitles.services.aboutUsPage',
        appDevelopmentPage: 'sectionNavTitles.services.appDevelopmentPage',
        mobileAppDevelopmentPage: 'sectionNavTitles.services.mobileAppDevelopmentPage',
        webAppDevelopmentPage: 'sectionNavTitles.services.webAppDevelopmentPage',
        berlin: 'sectionNavTitles.services.berlin',
    },
    offices: {
        homepage: 'sectionNavTitles.offices.homepage',
        aboutUsPage: 'sectionNavTitles.offices.aboutUsPage',
        analysisPage: 'sectionNavTitles.offices.analysisPage',
        appDevelopmentPage: 'sectionNavTitles.offices.appDevelopmentPage',
        mobileAppDevelopmentPage: 'sectionNavTitles.offices.mobileAppDevelopmentPage',
        webAppDevelopmentPage: 'sectionNavTitles.offices.webAppDevelopmentPage',
        berlin: 'sectionNavTitles.offices.berlin',
        prague: 'sectionNavTitles.offices.prague',
        design: 'sectionNavTitles.offices.design',
    },
    inquiry: {
        homepage: 'sectionNavTitles.inquiry.homepage',
        aboutUsPage: 'sectionNavTitles.inquiry.aboutUsPage',
        analysisPage: 'sectionNavTitles.inquiry.analysisPage',
        appDevelopmentPage: 'sectionNavTitles.inquiry.appDevelopmentPage',
        mobileAppDevelopmentPage: 'sectionNavTitles.inquiry.mobileAppDevelopmentPage',
        webAppDevelopmentPage: 'sectionNavTitles.inquiry.webAppDevelopmentPage',
    },
    principles: {
        design: 'sectionNavTitles.principles.design',
    },
    gallery: {
        berlin: 'sectionNavTitles.gallery.berlin',
        prague: 'sectionNavTitles.gallery.prague',
    },
    development: {
        mobile: 'sectionNavTitles.development.mobile',
        web: 'sectionNavTitles.development.web',
        design: 'sectionNavTitles.development.design',
        backend: 'sectionNavTitles.development.backend',
    },
    numbers: {
        aboutUsPage: 'sectionNavTitles.numbers.aboutUsPage',
    },
    testimonials: {
        aboutUsPage: 'sectionNavTitles.testimonials.aboutUsPage',
        berlin: 'sectionNavTitles.testimonials.berlin',
    },
    leadership: {
        aboutUsPage: 'sectionNavTitles.leadership.aboutUsPage',
    },
    mission: {
        aboutUsPage: 'sectionNavTitles.mission.aboutUsPage',
    },
    values: {
        aboutUsPage: 'sectionNavTitles.values.aboutUsPage',
    },
    vision: {
        aboutUsPage: 'sectionNavTitles.vision.aboutUsPage',
    },
    wrote: {
        aboutUsPage: 'sectionNavTitles.wrote.aboutUsPage',
    },
    workshop: {
        analysisPage: 'sectionNavTitles.workshop.analysisPage',
    },
    workshopProcess: {
        analysisPage: 'sectionNavTitles.workshopProcess.analysisPage',
    },
    buzzwords: {
        analysisPage: 'sectionNavTitles.buzzwords.analysisPage',
    },
    quote: {
        analysisPage: 'sectionNavTitles.quote.analysisPage',
    },
    process: {
        appDevelopmentPage: 'sectionNavTitles.process.appDevelomentPage',
        design: 'sectionNavTitles.process.design',
    },
    technologies: {
        mobileAppDevelopmentPage: 'sectionNavTitles.technologies.mobileAppDevelopmentPage',
        webAppDevelopmentPage: 'sectionNavTitles.technologies.webAppDevelopmentPage',
    },
    blogPosts: {
        mobileAppDevelopmentPage: 'sectionNavTitles.blogPosts.mobileAppDevelopmentPage',
        webAppDevelopmentPage: 'sectionNavTitles.blogPosts.webAppDevelopmentPage',
    },
    why: {
        appDevelopmentPage: 'sectionNavTitles.why.appDevelomentPage',
    },
    footer: 'sectionNavTitles.footer',
    career: {
        positions: 'sectionNavTitles.career.positions',
        gallery: 'sectionNavTitles.career.gallery',
    },
};
